import { styled } from '@mui/material/styles';

export const VolumeWrapper = styled('div')(({ theme }) => ({
  minWidth: '200px',
  padding: theme.spacing(1, 2),
  display: 'flex',
  alignItems: 'center',
  '& .MuiSlider-root': {
    marginRight: theme.spacing(2),
  },
}));
